(function () {
  angular.module("ticketco/ticketbuyer/retrieve_tickets")
    .controller("retrieveTicketsDialogController", retrieveTicketsDialogController);

  function retrieveTicketsDialogController(RetrieveTicketsPersistence) {
    var self = this;
    self.loading = false;

    self.retrieveCommand = function (model) {
      self.loading = true;
      return RetrieveTicketsPersistence.retrieve(model)
        .then(function (res) {
          self.result = res;
          return res;
        })
        .catch(function (err) {
          self.loading = false;
          self.errors = err;
          console.error(err);
        });
    };
  }
}());
